export { default } from "./CmsMenu";
